import { Component, Input, OnInit, signal } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Checkout } from 'src/app/state/user/checkouts/models/checkout';
import { CustomerType } from 'src/app/models/client-configuration';

@Component({
  selector: 'app-return-button',
  templateUrl: './return-button.component.html',
  styleUrls: ['./return-button.component.scss', '../base-button.scss'],
})
export class ReturnButtonComponent extends BaseButtonComponent implements OnInit {
  @Input()
  isMoreOption: string;

  @Input()
  isHoldItem: boolean;
  checkout: Checkout;
  customerType: CustomerType;

  readonly showReturnCheckoutDialog = signal<boolean>(false);

  ngOnInit() {
    this.checkout = this.checkoutsFacade.getCheckoutByRecordId(this.record.id, this.issueDate, this.rhId);
    this.customerType = this.configService.customerType;
  }

  doReturn() {
    this.showReturnCheckoutDialog.set(false);
    this.checkoutsFacade.postReturnCheckout(this.checkout.id).subscribe(() => {
      this.toastService.showToastSolution('messages.checkouts.return');

      this.ratingDialogFacade.openDialog(this.record);
      this.updateAvailability();
    });
  }

  cancelHold() {
    this.doAction(
      () => {
        const hold = this.holdsFacade.getHoldByRecordId(this.record.id, this.issueDate, this.rhId);
        this.holdsFacade.deleteHold(hold.id).subscribe(
          () => {
            this.toastService.showToast('messages.holds.cancel');
          },
          () => {},
          () => {
            this.waiting = false;
          }
        );
      },
      null,
      true
    );
  }
}
